import { useInstanceConfigQuery } from "@certa/queries/hooks/config.hook";

const toggleName = "DISABLE_NEW_WORKFLOW_PROGRESS_MAP";

/**
 * Toggle for disabling new workflow progress map
 */
export const useNewWorkflowProgressMapDisabled = (): boolean => {
  const { data: config } = useInstanceConfigQuery();
  const isToggleDisabled =
    config?.custom_ui_labels.specialFeatures?.includes(toggleName);

  return !!isToggleDisabled;
};
